import { HttpHeaders } from "@angular/common/http";

export const environment = {
  // Dev environment config
  production: false,
  contactFormUrl: 'https://eo25v7qqfl.execute-api.us-east-1.amazonaws.com/submit',
  reCAPTCHASiteKey: '6LcBqTQpAAAAAN8YqYk6Ya98qng5OkGaBp0eMCrh',
  HTTP_OPTIONS: {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  }
};
